import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';

type ProgressButtonProps = {
    onClick?: (event: React.FormEvent) => void;
    navRoute: string;
    text: string;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    locationState?: any;
    buttonStyle?: string;
    dataTestid?: string;
};

const ProgressButton = memo(ProgressButtonMemo, (prevProps, currentProps) => {
    return (
        prevProps.buttonStyle === currentProps.buttonStyle &&
        prevProps.locationState === currentProps.locationState &&
        prevProps.navRoute === currentProps.navRoute &&
        prevProps.text === currentProps.text
    );
});

function ProgressButtonMemo({
    onClick,
    navRoute,
    text,
    locationState = {},
    buttonStyle,
    dataTestid = ''
}: ProgressButtonProps) {
    return (
        <NavLink
            onClick={onClick}
            to={navRoute}
            state={locationState}
            data-testid={dataTestid}
            className={buttonStyle}>
            {text}
        </NavLink>
    );
}

export default ProgressButton;
